import PropTypes from "prop-types";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Box, Stack, Drawer } from "@mui/material";
import useResponsive from "../../../hooks/useResponsive";
import { NAV } from "../../../config-global";
import Scrollbar from "../../../components/scrollbar";
import { NavSectionVertical } from "../../../components/nav-section";
import { getDashboardNavConfig } from "./config-navigation";
import NavDocs from "./NavDocs";
import NavAccount from "./NavAccount";
import NavToggleButton from "./NavToggleButton";
import { useAuthContext } from "../../../auth/useAuthContext";
import logo from "../../../assets/logo.png";

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function NavVertical({ openNav, onCloseNav, isVenueOnline, handleVenueOnlineStatusChange }) {
  const { pathname } = useLocation();
  const isDesktop = useResponsive("up", "lg");
  const { user } = useAuthContext();
  const navConfig = useMemo(() => getDashboardNavConfig(user), [user]);

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 1,
          px: 2.5,
          flexShrink: 0,
        }}
      >
        <center>
          <img width={150} src={logo} alt="logo" />
        </center>
        <NavAccount isVenueOnline={isVenueOnline} handleVenueOnlineStatusChange={handleVenueOnlineStatusChange} />
      </Stack>
      <NavSectionVertical data={navConfig} />
      <Box sx={{ flexGrow: 1 }} />
      <NavDocs />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: "transparent",
              borderRightStyle: "dashed",
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
